export * from "./Arithmetic";
export * from "./FundamentalOperations";
export * from "./MCMMCD";

export const arithmeticItems = {
  Introducción: {
    path: "/matematicas/introduccion-aritmetica",
    subtopics: {
      Aritmética: {
        path: "/matematicas/introduccion-aritmetica",
        scrollToId: "aritmetica",
      },
      "Clasificación números": {
        path: "/matematicas/introduccion-aritmetica",
        scrollToId: "clasificacionNumeros",
      },
      "Valor absoluto": {
        path: "/matematicas/introduccion-aritmetica",
        scrollToId: "valorAbsoluto",
      },
    },
  },
  "Operaciones fundamentales": {
    path: "/matematicas/operaciones-fundamentales",
    subtopics: {
      "Suma y resta": {
        path: "/matematicas/operaciones-fundamentales",
        scrollToId: "sumaResta",
      },
      "Multiplicación y división": {
        path: "/matematicas/operaciones-fundamentales",
        scrollToId: "multiplicacionDivision",
      },
      Divisibilidad: {
        path: "/matematicas/operaciones-fundamentales",
        scrollToId: "divisibilidad",
      },
      Potenciación: {
        path: "/matematicas/operaciones-fundamentales",
        scrollToId: "potenciacion",
      },
      Radicación: {
        path: "/matematicas/operaciones-fundamentales",
        scrollToId: "radicacion",
      },
      "Simplificación de raíces": {
        path: "/matematicas/operaciones-fundamentales",
        scrollToId: "simplificacionRaices",
      },
      Logaritmación: {
        path: "/matematicas/operaciones-fundamentales",
        scrollToId: "logaritmacion",
      },
      "Jerarquía de operaciones": {
        path: "/matematicas/operaciones-fundamentales",
        scrollToId: "jerarquiaOperaciones",
      },
    },
  },
  "MCM y MCD": {
    path: "/matematicas/mcm-y-mcd",
    subtopics: {
      "Números primos": {
        path: "/matematicas/mcm-y-mcd",
        scrollToId: "numerosPrimos",
      },
      "Mínimo común múltiplo": {
        path: "/matematicas/mcm-y-mcd",
        scrollToId: "mcm",
      },
      "Máximo común divisor": {
        path: "/matematicas/mcm-y-mcd",
        scrollToId: "mcd",
      },
    },
  },
};
